export default {
  path: '/agricultural',
  name: 'Agricultural',
  meta: {
    title: '农事',
    showTabBar: true
  },
  component: () => import('@/views/Agricultural')
}

